import { SliceCaseReducers } from "@reduxjs/toolkit"
import { EnumEndpointsName } from "@/constants/app/type"
import { GlobalState } from "./features/global/type"
import { UserState } from "./features/user/type"
import { FlightState } from "./features/flight/type"
import { BookingState } from "./features/booking/type"
import { VoucherState } from "./features/voucher/type"
import { BlogState } from "./features/blog/type"
import { Axios } from "axios"

export enum EnumReduces {
  USER = "user",
  FLIGHT = "flight",
  GLOBAL = "global",
  BOOKING = "booking",
  HOTEL = 'hotel',
  TOUR = 'tour',
  VOUCHER = 'voucher',
  BLOG = 'blog',
  ESIM = 'esim',
}

export type TypeCommonAPIState<T> = {
  loading: boolean,
  success: boolean,
  error: any,
  data: T,
  filter?: any,
  called: boolean,
  primaryKeys?: string[]
}

export type TypeActions = {
  [EnumReduces.USER]: SliceCaseReducers<UserState>,
  [EnumReduces.FLIGHT]: SliceCaseReducers<FlightState>,
  [EnumReduces.GLOBAL]: SliceCaseReducers<GlobalState>,
  [EnumReduces.BOOKING]: SliceCaseReducers<BookingState>,
  [EnumReduces.VOUCHER]: SliceCaseReducers<VoucherState>,
  [EnumReduces.BLOG]: SliceCaseReducers<BlogState>,
}

export type TypeServices = {
  [prop in EnumEndpointsName]: (input: { params?: any, body?: any }, headers?: any) => any
}

export type TypeControllers = {
  [prop in EnumEndpointsName]: AbortController
}